import { fetch } from '../services/fetch'
import { routes } from '../config'

export const getPets = payload => fetch.post(routes.getPets, payload)

export const getSpecies = payload => fetch.post(routes.getSpecies, payload)

export const getRaces = (id, payload) => fetch.post(routes.getRaces, { id }, payload)

export const createPet = (pet, payload) => fetch.post(routes.createPet, pet, payload)

export const updatePet = (pet, payload) => fetch.post(routes.updatePet, pet, payload)

export const deletePet = (pet, payload) => fetch.post(routes.deletePet, pet, payload)
